import { render, staticRenderFns } from "./TriggerSMS.vue?vue&type=template&id=679c5334&scoped=true&"
import script from "./TriggerSMS.vue?vue&type=script&lang=js&"
export * from "./TriggerSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c5334",
  null
  
)

export default component.exports